import { render, staticRenderFns } from "./AddOrModify.vue?vue&type=template&id=3e52fdfe&scoped=true"
import script from "./AddOrModify.vue?vue&type=script&lang=js"
export * from "./AddOrModify.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52fdfe",
  null
  
)

export default component.exports